module.exports = __webpack_public_path__ + "static/media/Soundtrack.ec92981e.mp3";